import axios from 'axios';
import I18n from "i18next";
const uploadUrl = process.env.REACT_APP_MEDCONNECT + '/room/{roomUuid}/attachments/{participantUuid}';

const FetchUpload = (
    token: string,
    room: any | null,
    participant: any | null | undefined,
    data: any,
    progressBar:any,
    onFail: any,
    receipientId?: string | null
) => {
    let url = uploadUrl;
    url = url.replace('{roomUuid}', room.uuid);
    url = url.replace('{participantUuid}', participant.uuid);

    // Validate attachment size (max 10 MB)
    try {
        let totalSize = 0;

        if (data instanceof FormData) {
            for (const [, value] of (data as any).entries()) {
                if (value && typeof (value as any).size === 'number') {
                    totalSize += (value as any).size;
                }
            }
        } else if (data && typeof (data as any).size === 'number') {
            totalSize = (data as any).size;
        }

        const MAX_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
        if (totalSize > MAX_SIZE) {
            const err = new Error(I18n.t('inputBar:fileIsToBig'));
            if (typeof onFail === 'function') onFail(err);
            return;
        }
    } catch (e) {
        // If size detection fails, continue with upload rather than blocking it
    }

    const queryParts: string[] = [];
    queryParts.push("bearer=" + encodeURIComponent(token));

    if (receipientId) {
        queryParts.push("recipientUuid=" + encodeURIComponent(receipientId));
    }

    axios.request({
        method:"post",
        url: url + "?" + queryParts.join("&"),
        data: data,
        onUploadProgress: (progress) => {
          progressBar(progress.loaded, progress.total)
        },
    }).then(() => {

    }).catch((error: any) => {
        onFail(error)
    })
};

export default FetchUpload;
